import * as React from 'react';

const FallBackInput = ({ placeholder }) => <input
	className="form-control"
	placeholder={placeholder}
/>;

export default FallBackInput;
